import Swiper from 'swiper/bundle';

(function ($) {

    //swiper
    let swiper = new Swiper(".section-slider-with-blocks .slider-blocks", {
        slidesPerView: 'auto',
        spaceBetween: 8,
        centeredSlides: false,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        navigation: {
            nextEl: ".section-slider-with-blocks .swiper-button-next",
            prevEl: ".section-slider-with-blocks .swiper-button-prev",
        },
        pagination: {
            el: ".section-slider-with-blocks .swiper-pagination",
            clickable: true,
        }
    });

})(jQuery);